const thirdPartyApp = [
    {
        "id": 1,
        "name": "CRM",
    },
    {
        "id": 2,
        "name": "SAP",
    },
]

export { thirdPartyApp }